import { z } from 'zod'
import { updateInvoiceSchema } from '@/features/invoices/schemas'
import { validateResponseIsOk } from '@/shared/api/validation'
import { createAssetManagementClient } from '@/shared/api/client'

const client = createAssetManagementClient()

export const updateInvoice = (invoiceId: number, values: z.infer<typeof updateInvoiceSchema>) =>
  validateResponseIsOk(
    client.sendPatch(
      `billing/invoices/${invoiceId}/configurations`,
      { data: updateInvoiceSchema.parse(values) }
    )
  ).then(
    () => { }
  )
